const phoneCountryCodes = [
  {
    code: 'AR',
    name: 'Argentina',
    phoneCode: '+54',
  },
  {
    code: 'AU',
    name: 'Australia',
    phoneCode: '+61',
  },
  {
    code: 'BR',
    name: 'Brazil',
    phoneCode: '+55',
  },
  {
    code: 'CN',
    name: 'China',
    phoneCode: '+86',
  },
  {
    code: 'FR',
    name: 'France',
    phoneCode: '+33',
  },
  {
    code: 'DE',
    name: 'Germany',
    phoneCode: '+49',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    phoneCode: '+44',
  },
  {
    code: 'IN',
    name: 'India',
    phoneCode: '+91',
  },
  {
    code: 'IT',
    name: 'Italy',
    phoneCode: '+39',
  },
  {
    code: 'JP',
    name: 'Japan',
    phoneCode: '+81',
  },
  {
    code: 'KR',
    name: 'South Korea',
    phoneCode: '+82',
  },
  {
    code: 'MX',
    name: 'Mexico',
    phoneCode: '+52',
  },
  {
    code: 'NG',
    name: 'Nigeria',
    phoneCode: '+234',
  },
  {
    code: 'NL',
    name: 'Netherlands',
    phoneCode: '+31',
  },
  {
    code: 'NO',
    name: 'Norway',
    phoneCode: '+47',
  },
  {
    code: 'RU',
    name: 'Russia',
    phoneCode: '+7',
  },
  {
    code: 'SE',
    name: 'Sweden',
    phoneCode: '+46',
  },
  {
    code: 'CH',
    name: 'Switzerland',
    phoneCode: '+41',
  },
  {
    code: 'ZA',
    name: 'South Africa',
    phoneCode: '+27',
  },
  {
    code: 'ES',
    name: 'Spain',
    phoneCode: '+34',
  },
  {
    code: 'SG',
    name: 'Singapore',
    phoneCode: '+65',
  },
  {
    code: 'US',
    name: 'United States',
    phoneCode: '+1',
  },
  {
    code: 'PH',
    name: 'Philippines',
    phoneCode: '+63',
  },
  {
    code: 'PL',
    name: 'Poland',
    phoneCode: '+48',
  },
  {
    code: 'ID',
    name: 'Indonesia',
    phoneCode: '+62',
  },
  {
    code: 'MY',
    name: 'Malaysia',
    phoneCode: '+60',
  },
  {
    code: 'BN',
    name: 'Brunei',
    phoneCode: '+673',
  },
  {
    code: 'TH',
    name: 'Thailand',
    phoneCode: '+66',
  },
  {
    code: 'MM',
    name: 'Myanmar',
    phoneCode: '+95',
  },
  {
    code: 'LA',
    name: 'Laos',
    phoneCode: '+856',
  },
  {
    code: 'KH',
    name: 'Cambodia',
    phoneCode: '+855',
  },
  {
    code: 'VN',
    name: 'Vietnam',
    phoneCode: '+84',
  },
]

export default phoneCountryCodes
